/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ date: NonNullable<unknown> }} Coinvestments_Closedeal_Card_Closedsubtitle3Inputs */

const en_coinvestments_closedeal_card_closedsubtitle3 = /** @type {(inputs: Coinvestments_Closedeal_Card_Closedsubtitle3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`This deal was closed on ${i?.date}`)
};

/**
* | output |
* | --- |
* | "This deal was closed on {date}" |
*
* @param {Coinvestments_Closedeal_Card_Closedsubtitle3Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_closedeal_card_closedsubtitle3 = /** @type {((inputs: Coinvestments_Closedeal_Card_Closedsubtitle3Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Closedeal_Card_Closedsubtitle3Inputs, { locale?: "en" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_closedeal_card_closedsubtitle3(inputs)
});
export { coinvestments_closedeal_card_closedsubtitle3 as "coInvestments_closeDeal_card_closedSubtitle" }